<template>
    <main class="page about">

        <section class="auto start medium background-white">
            <div class="inner">
                <div class="title large">
                    <h1> We are here to help product teams <span class="highlight">succeed.</span> </h1>
                    <h2>We're building the best next-generation feedback tool for product managers and teams everywhere</h2>
                </div>
            </div>
        </section>

        <section class="round white">
            <div class="inner">

                <div class="row info-boxes" style="width:100%">
                    <div class="col-xs-12 col-sm-6">
                        <div class="info-box meta-box">
                            <div class="pre-head">What is Sleekplan</div>
                            <div class="content">
                                Sleekplan is a powerful all-in-one feedback solution that brings a feature voting board, roadmap, changelog and satisfaction surveys to your website or app.
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6">
                        <div class="info-box meta-box">
                            <div class="pre-head">Community</div>
                            <div class="content">
                                Have a look at the upcoming features at Sleekplan, upvote and share your feedback.
                                <a href="https://feedback.sleekplan.com">Join our feedback community -></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-9">
                        <div class="info-box cyan shadow founder-box">
                            <div class="founder-mission">Mission</div>
                            <div class="founder-quote">Sleekplan is on a mission to make an improvement over what's similar today in the world of customer feedback tools.</div>
                            <div class="founder">
                                <div class="image">
                                    <img src="@/assets/media/general/marcograf.jpg">
                                </div>
                                <div class="info">
                                    <div class="name">Marco Graf</div>
                                    <div class="meta">Founder of Sleekplan</div>
                                    <div class="social">
                                        <a href="https://twitter.com/mrcogrf" target="_blank" rel="nofollow">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><title>Twitter</title><path d="M496 109.5a201.8 201.8 0 01-56.55 15.3 97.51 97.51 0 0043.33-53.6 197.74 197.74 0 01-62.56 23.5A99.14 99.14 0 00348.31 64c-54.42 0-98.46 43.4-98.46 96.9a93.21 93.21 0 002.54 22.1 280.7 280.7 0 01-203-101.3A95.69 95.69 0 0036 130.4c0 33.6 17.53 63.3 44 80.7A97.5 97.5 0 0135.22 199v1.2c0 47 34 86.1 79 95a100.76 100.76 0 01-25.94 3.4 94.38 94.38 0 01-18.51-1.8c12.51 38.5 48.92 66.5 92.05 67.3A199.59 199.59 0 0139.5 405.6a203 203 0 01-23.5-1.4A278.68 278.68 0 00166.74 448c181.36 0 280.44-147.7 280.44-275.8 0-4.2-.11-8.4-.31-12.5A198.48 198.48 0 00496 109.5z"/></svg>
                                        </a>
                                        <a href="https://www.linkedin.com/in/marcograf/" target="_blank" rel="nofollow">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Linkedin</title><path d="M444.17 32H70.28C49.85 32 32 46.7 32 66.89v374.72C32 461.91 49.85 480 70.28 480h373.78c20.54 0 35.94-18.21 35.94-38.39V66.89C480.12 46.7 464.6 32 444.17 32zm-273.3 373.43h-64.18V205.88h64.18zM141 175.54h-.46c-20.54 0-33.84-15.29-33.84-34.43 0-19.49 13.65-34.42 34.65-34.42s33.85 14.82 34.31 34.42c-.01 19.14-13.31 34.43-34.66 34.43zm264.43 229.89h-64.18V296.32c0-26.14-9.34-44-32.56-44-17.74 0-28.24 12-32.91 23.69-1.75 4.2-2.22 9.92-2.22 15.76v113.66h-64.18V205.88h64.18v27.77c9.34-13.3 23.93-32.44 57.88-32.44 42.13 0 74 27.77 74 87.64z"/></svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-3">
                        <div class="info-box about-box">
                            <div class="title first">Headquater</div>
                            <div class="text">Munich, Germany</div>
                            <div class="title" style="margin-top: 30px;">Tracked Sessions</div>
                            <div class="text">30M+ /month</div>
                            <div class="title">Tracked Feedback</div>
                            <div class="text">100K+</div>
                            <div class="title">Countries</div>
                            <div class="text">34</div>
                        </div>
                    </div>
                </div>

                

            </div>
        </section>     

        <!--
        <section class="dark">
            <div class="inner">
                
                <div class="content-large center full">
                    <h2>Powering Innovation Worldwide<br><span class="sub">One Insight at a Time</span></h2>
                    <span>Join thousands of teams leveraging in-app feedback to refine their products, enhance user experiences, and deliver new features that matter. Together, we’re driving continuous improvement.</span>
                </div>
                
                <div class="stats" v-if="stats">

                    <div class="stats-box">
                        <div class="item">
                            <div class="value">
                                {{ stats.total_data }}
                            </div>
                            <div class="key">User Sessions Covered</div>
                            <div class="description">in the last 30 days</div>
                        </div>
                        <div class="item">
                            <div class="value">
                                {{ stats.total_transactions }}
                            </div>
                            <div class="key">User Feedback Tracked</div>
                            <div class="description">in the last 30 days</div>
                        </div>
                        <a class="item" taregt="_blank" rel="nofollow">
                            <div class="value">
                                {{ stats.total_updates }}
                            </div>
                            <div class="key">New Features Shipped</div>
                            <div class="description">in the last 30 days</div>
                        </a>
                    </div>

                    <div class="stats-graph" v-if="stats">
                        <canvas id="commit-chart" height="300" style="width: 100%;"></canvas>
                    </div>

                </div>
                <div v-else class="stats">
                    <div class="stats-loading">Loading stats...</div>
                </div>

            </div>
        </section>
        -->

        <section class="white round">
            <div class="inner">
                
                <svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512' style="width: 50px;margin-bottom: 50px;fill: var(--bg-color-dark);"><title>Shield Checkmark</title><path d='M479.07 111.36a16 16 0 00-13.15-14.74c-86.5-15.52-122.61-26.74-203.33-63.2a16 16 0 00-13.18 0C168.69 69.88 132.58 81.1 46.08 96.62a16 16 0 00-13.15 14.74c-3.85 61.11 4.36 118.05 24.43 169.24A349.47 349.47 0 00129 393.11c53.47 56.73 110.24 81.37 121.07 85.73a16 16 0 0012 0c10.83-4.36 67.6-29 121.07-85.73a349.47 349.47 0 0071.5-112.51c20.07-51.19 28.28-108.13 24.43-169.24zm-131 75.11l-110.8 128a16 16 0 01-11.41 5.53h-.66a16 16 0 01-11.2-4.57l-49.2-48.2a16 16 0 1122.4-22.86l37 36.29 99.7-115.13a16 16 0 0124.2 20.94z'/></svg>

                <div class="content-large center">
                    <span>Sleekplan takes your security and the security of your website visitors very seriously. Our team implemented security best-practices at every level. Sleekplan always refused to sell any data and our policy is to respect your data privacy. Our business model is based on paid Sleekplan subscriptions. Not on your data! </span>
                    <br><br>
                    <span>All public network channels on the Sleekplan platform are fully encrypted. This comes for both our app (Web resources), and the widget implemented in your app (user messages and user data). Sleekplan uses Amazon Web Services to host all of our applications, databases and static resources and we back-up everything continuously to ensure your data stays safe. <router-link to="/security/">More about security</router-link>.</span>
                </div>

            </div>
        </section>

    </main>
</template>

<script>
import Chart from 'chart.js';

export default {


    /** ----------------------------------------------------
     * View => Base data
     ----------------------------------------------------- */
    data() {
        
        // data
		return {
            stats: false,
            newsletter_mail: '',
            newsletter_done: false,
        };

    },


    /** ----------------------------------------------------
     * View => Methods
     ----------------------------------------------------- */
    methods: {

        /**
         *  load dev stats from marcos api
         */
        load_stats() {

            // skip on prerender
            if (navigator.userAgent == 'ReactSnap')
                return false;

            fetch('https://service-n8n.sleekplan.cloud/webhook/043b9263-7d0d-4739-9995-fff6dcc37b8c')
            .then((response) => {
                response.json().then(function(data) {
                    this.stats = data;
                    setTimeout(function(){
                        this.load_chart();
                    }.bind(this), 500);

                }.bind(this));
            })
            .then(() => {});
  
        },

        /**
         *  load commit chart
         */
        load_chart() {

            // init chart element
            var links_pageviews = document.getElementById('commit-chart').getContext('2d');
            var canvasHeight = links_pageviews.canvas.height;

            // Define the gradients from top (0) to bottom (canvasHeight)
            var analytics_satisfaction_gs = links_pageviews.createLinearGradient(0, 0, 0, 900);
            analytics_satisfaction_gs.addColorStop(0, '#5aa7de');
            analytics_satisfaction_gs.addColorStop(1, '#00b3a4');

            var analytics_satisfaction_gf = links_pageviews.createLinearGradient(0, 0, 0, 900);
            analytics_satisfaction_gf.addColorStop(0, "rgba(90, 167, 222, 0.5)");
            analytics_satisfaction_gf.addColorStop(1, "rgba(41, 43, 49, 0.1)");

            // draw a chart
            new Chart(links_pageviews, {
                type: 'line',
                data: {
                    labels: this.stats.labels,
                    datasets: [{
                        borderColor: analytics_satisfaction_gs,
                        pointBorderColor: '#f5f8fa',
                        pointBackgroundColor: analytics_satisfaction_gs,
                        pointHoverBackgroundColor: analytics_satisfaction_gs,
                        pointHoverBorderColor: analytics_satisfaction_gs,
                        backgroundColor: analytics_satisfaction_gf,
                        fill: true,
                        pointRadius: 3,
                        borderWidth: 3,
                        label: 'User sessions',
                        data: this.stats.data,
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: false,
                    scales: {
                        yAxes: [{
                            display: true,
                            ticks: {
                                stepSize: 50000000,
                                display: true,
                                beginAtZero: false,
                                callback: function(value, index, values) {
                                    return value / 1e6 + 'M';
                                }
                            },
                            gridLines: {
                                zeroLineColor: "rgba(255, 255, 255, 0.05)",
                                display: true,
                                color: "rgba(255, 255, 255, 0.05)",
                                drawBorder: false
                            },
                            position: 'right',
                        }],
                        xAxes: [{
                            display: true,
                            ticks: {
                                stepSize: 1,
                                beginAtZero: true,
                            },
                            gridLines: {
                                zeroLineColor: "rgba(255, 255, 255, 0.05)",
                                display: true,
                                color: "rgba(255, 255, 255, 0.05)",
                                drawBorder: false
                            }
                        }]
                    }
                }
            });

        },


	},


    /** ----------------------------------------------------
     * View => On Mount
     ----------------------------------------------------- */
    mounted() {

        // add class
        this.$parent.$refs['home-header'].menu_transparent = false;

        // load stats
        this.load_stats();

    },


    /** ----------------------------------------------------
     * View => On Destroyed
     ----------------------------------------------------- */
    destroyed() {

        // remove class
        this.$parent.$refs['home-header'].menu_transparent = false;

    },


    /** ----------------------------------------------------
     * Header
     ----------------------------------------------------- */
    head: {
        // Meta title
        title: {
            inner: 'About',
            separator: '|',
            complement: 'Sleekplan'
        },
        // Meta tags
        meta: [
            { 
                name: 'description', 
                content: '', 
                id: 'desc' 
            },
            { name: 'robots', content: 'index,follow' },
        ],
        // Link tags
        link: [
            { 
                rel: 'canonical', 
                href: 'https://sleekplan.com' + location.pathname, 
                id: 'canonical' 
            },
        ]
    }


}
</script>